var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1-dia",
    "data-name": "1-dia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.012,
    height: 43.649,
    viewBox: "0 0 45.012 43.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_129",
    "data-name": "Rect\\xE1ngulo 129",
    width: 43.3,
    height: 8.192,
    transform: "translate(1 4.285)",
    fill: "#7dd6d9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_511",
    "data-name": "Trazado 511",
    d: "M45,32.138c0-.022.012-27.972.012-27.972A1.042,1.042,0,0,0,43.97,3.124h-5.7V1.043a1.043,1.043,0,1,0-2.085,0V3.124H28.458V1.043a1.043,1.043,0,1,0-2.085,0V3.124H18.641V1.043a1.043,1.043,0,0,0-2.085,0V3.124H8.824V1.043a1.043,1.043,0,0,0-2.086,0V3.124H1.045A1.042,1.042,0,0,0,0,4.167l0,38.44a1.042,1.042,0,0,0,1.043,1.043h32.4a1.047,1.047,0,0,0,.737-.305L44.708,32.812A1.08,1.08,0,0,0,45,32.138M2.088,5.209h4.65V7.29a1.043,1.043,0,0,0,2.086,0V5.209h7.732V7.29a1.043,1.043,0,0,0,2.085,0V5.209h7.731V7.29a1.043,1.043,0,0,0,2.085,0V5.209h7.731V7.29a1.043,1.043,0,1,0,2.085,0V5.209h4.653v6.548H2.088Zm0,8.634H42.928V31.031H33.438A1.043,1.043,0,0,0,32.4,32.074v9.489H2.085Zm32.4,26.246V33.117h6.972Z",
    fill: "#8898aa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Basic_Yoga",
    "data-name": "Basic Yoga",
    d: "M9.071,25.562h-2v-10.1H4.629V13.991l4.442-.429Z",
    transform: "translate(15.371 6.438)",
    fill: "#8898aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8ef9ea52d74dcd4ffb424215a3c27621.svg";
export { ForwardRef as ReactComponent };